export enum EntityRecordTypes {
  import = 'import',
  web = 'web',
}
